import { UtilitarioService } from "@app/services/utilitario.service";

export class Rateio{
    public Id: number;
    public ParticipanteId: number;
    public Valor: number;
    public Vencimento: string;
    public Historico: string;
    public NumeroParcelas: number;
    public FaturamentoBase: string;
    public Unidades: RateioUnidade[];

    constructor(){
        this.Id = 0;
        this.ParticipanteId = 0;
        this.Valor = 0;
        this.Vencimento = UtilitarioService.retornaDataAtualMaisDiasISO(0);
        this.Historico = '';
        this.NumeroParcelas = 1;
        this.FaturamentoBase = 'MENSAL'
        this.Unidades = [];
    }
}

export class RateioUnidade{
    public UnidadeId: number;
    public UnidadeDescricao: number;
    public UnidadePercentual: number;
}

export class RateioCriacaoInput{
    public ParticipanteId: number;
    public DemonstrativoDeResultadoId: number;
    public Vencimento: string; 
    public Valor: number; 
    public Historico: string;
    public FaturamentoDataInicial: string;
    public FaturamentoDataFinal: string;
    public NumeroParcelas: number;
    public Unidades: RateioUnidadeInput[];

    constructor(){
        this.NumeroParcelas = 1;
        this.Valor = 0;
    }
}

export class RateioUnidadeInput{
    public UnidadeId: number;
    public UnidadeDescricao: string;
    public UnidadePercentual: number;
    public UnidadePercentualSugerido: number;
}